var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCowLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 400,
    viewBox: "0 0 400 400",
    width: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f2cd16",
    height: 400,
    rx: 200,
    width: 400
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m166.373 304c-13.367 0-25.195-8.655-29.237-21.395l-20.778-65.494h-12.775c-13.3671 0-25.1952-8.655-29.2367-21.395l-12.3463-38.916h46.309l-24.425-36.8h231.432l-24.425 36.8h46.309l-12.346 38.916c-4.042 12.74-15.87 21.395-29.237 21.395h-12.775l-20.778 65.494c-4.042 12.74-15.87 21.395-29.237 21.395zm-15.697-104.778c0 9.88 7.377 17.889 16.478 17.889s16.478-8.009 16.478-17.889-7.377-17.889-16.478-17.889-16.478 8.009-16.478 17.889zm97.849 0c0 9.88-7.378 17.889-16.479 17.889s-16.478-8.009-16.478-17.889 7.377-17.889 16.478-17.889 16.479 8.009 16.479 17.889z",
    fill: "#544003",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowLogo);
export default __webpack_public_path__ + "static/media/cow-logo.b9e3a35ee2fb8c6acaa9796bd994d545.svg";
export { ForwardRef as ReactComponent };